import type { IconData } from '@stacksjs/iconify-core'

export const contentEdit: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8.5 7.5V4L11.775.725a2.475 2.475 0 0 1 3.5 3.5L12 7.5z\"/><path fill=\"currentColor\" d=\"M7 2H0v14h14V9H7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentEdit
